import { render, staticRenderFns } from "./ProjectReportsMarketParentBar.component.vue?vue&type=template&id=72b94d26&scoped=true"
import script from "./ProjectReportsMarketParentBar.component.vue?vue&type=script&lang=js"
export * from "./ProjectReportsMarketParentBar.component.vue?vue&type=script&lang=js"
import style0 from "./ProjectReportsMarketParentBar.component.vue?vue&type=style&index=0&id=72b94d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b94d26",
  null
  
)

export default component.exports